import { useEffect, useState } from "react";
import { api_private_get, api_private_post, showAlert } from "script";

export default function ProfileTab() {
  const [accountInfo, setAccountInfo] = useState(null);
  // const [accountPreferences, setAccountPreferences] = useState(null);
  const [newDisplayName, setNewDisplayName] = useState("");

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleChangeDisplayName = (e) => {
    e.preventDefault();
    console.log("Changing display name to:", newDisplayName);
    api_private_post(
      "/account/change_display_name",
      { display_name: newDisplayName },
      (data) => {
        if (data.success) {
          // wait 100 ms to ensure the backend has processed the change
          // setTimeout(() => {
          fetchProfileData(); // Refresh the profile data after changing display name
          showAlert("Preference saved!", "success");
          // clear the input field
          setNewDisplayName("");
          // }, 1);
        } else {
          console.error("Failed to change display name:", data.error);
          showAlert("Failed to change display name: " + data.error, "danger");
        }
      },
      (error) => {
        console.error("Error changing display name:", error);
        showAlert("Failed to change display name: " + error, "danger");
      },
    );
  };

  const fetchProfileData = () => {
    api_private_get("/account/get_info", (data) => {
      console.log("get_info data:", data);
      setAccountInfo(data);
    });
    // api_private_get('/account/get_preferences', (data) => {
    //     console.log("get_preferences data:", data);
    //     setAccountPreferences(data);
    // });
  };

  const handleChangePassword = (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      showAlert("New password and confirmation do not match.", "danger");
      return;
    }
    api_private_post(
      "/account/change_password",
      { current_password: currentPassword, new_password: newPassword },
      (data) => {
        console.log("Change password response:", data);
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
        if (data.success) {
          showAlert("Password changed successfully!", "success");
        } else {
          showAlert("Failed to change password: " + data.error, "danger");
        }
      },
    );
  };

  useEffect(() => {
    fetchProfileData();
  }, []);

  // Real-currency accounts use display_name as the legal full name (must match
  // Interac details), so it is shown as "Full Name" and cannot be changed.
  const isReal = accountInfo?.account_type === "real";

  return (
    <div>
      <div className="pay_method__paymethod p-4 p-lg-6 p2-bg rounded-8 mb-5">
        <div className="pay_method__paymethod-title mb-5 mb-md-6">
          <h5 className="n10-color">About You</h5>
        </div>
        <div className="pay_method__formarea">
          {/* <form> */}
          <div className="d-flex align-items-center flex-wrap flex-md-nowrap gap-5 gap-md-6 mb-5">
            <div className="w-100">
              <label className="mb-3">
                {isReal ? "Full Name" : "Display Name"}
              </label>
              <input
                id="profile-display-name"
                className="n11-bg rounded-8"
                type="text"
                placeholder={isReal ? "Full Name" : "Display Name"}
                readOnly
                value={accountInfo?.display_name || ""}
              />
            </div>
            <div className="w-100">
              <label className="mb-3">User ID</label>
              <input
                id="profile-user-id"
                className="n11-bg rounded-8"
                style={{ fontFamily: "monospace" }}
                type="text"
                placeholder="User ID"
                readOnly
                value={accountInfo?.user_id || ""}
              />
            </div>
          </div>
          {/* <!-- <div
                            className="d-flex align-items-center gap-5 gap-md-6 mb-5 flex-wrap flex-md-nowrap">
                            <div className="w-100">
                                <label className="mb-3">Date Of Birth</label>
                                <div className="d-flex align-items-center gap-6 w-100">

                                    <div className="d-flex n11-bg rounded-8 w-50">
                                        <input type="text" placeholder="12">
                                    </div>
                                    <div className="d-flex n11-bg rounded-8 w-50">
                                        <input type="text" placeholder="09">
                                    </div>
                                    <div className="d-flex n11-bg rounded-8 w-50">
                                        <input type="text" placeholder="1999">
                                    </div>
                                </div>
                            </div>
                            <div className="w-100">
                                <label className="mb-3">Phone Number</label>
                                <div className="d-flex gap-2">
                                    <input className="w-25 n11-bg rounded-8" type="text"
                                        placeholder="+962">
                                    <input className="n11-bg rounded-8" type="text"
                                        placeholder="XX-XXX-XXXXX">
                                </div>
                            </div>
                        </div> --> */}
          {/* <!-- <div
                            className="d-flex align-items-center flex-wrap flex-md-nowrap gap-5 gap-md-6 mb-5">
                            <div className="w-100">
                                <label className="mb-3">Address</label>
                                <input className="n11-bg rounded-8" type="text"
                                    placeholder="Address...">
                            </div>
                            <div className="w-100">
                                <label className="mb-3">Country</label>
                                <select>
                                    <option data-display="Your country...">Your country...
                                    </option>
                                    <option value="1">Country 1</option>
                                    <option value="2">Country 2</option>
                                </select>
                            </div>
                        </div> --> */}
          <div className="d-flex align-items-center flex-wrap flex-md-nowrap gap-5 gap-md-6 mb-5">
            <div className="w-100">
              <label className="mb-3">Email</label>
              <input
                id="profile-email"
                className="n11-bg rounded-8"
                type="text"
                placeholder="Email"
                readOnly
                value={accountInfo?.email || ""}
              />
            </div>
            <div className="w-100">
              <label className="mb-3">Account Created</label>
              <input
                className="n11-bg rounded-8"
                type="text"
                placeholder="Account Created"
                readOnly
                value={accountInfo?.creation_time || ""}
              />
            </div>
          </div>
          {/* <!-- <div className="d-flex gap-2 align-items-start align-items-xl-center mb-5">
                            <input type="checkbox" id="demoCheckbox" name="checkbox"
                                value="1">
                            <label htmlFor="demoCheckbox" className="fs-seven">I authorize to collect and transmit my personal information for identity verification or <span className="g1-color"> similar uses as defined</span> in order to confirm my ability to use the website.</label>
                        </div>
                        <button className="cmn-btn py-3 px-10">Save</button> --> */}
          {/* </form> */}
        </div>
      </div>
      {!isReal && (
        <div className="pay_method__paymethod p-4 p-lg-6 p2-bg rounded-8 mb-5">
          <div className="pay_method__paymethod-title mb-5 mb-md-6">
            <h5 className="n10-color">Change Display Name</h5>
            <p className="fs-seven n4-color mt-2">
              The Display Name is a personalization feature that you can freely
              change at any time—it’s just for you and only visible to you. It
              won’t be shown to anyone else.
            </p>
          </div>
          <div className="pay_method__formarea">
            <form onSubmit={handleChangeDisplayName}>
              <div className="d-flex align-items-center flex-wrap flex-md-nowrap gap-5 gap-md-6 mb-5">
                <div className="w-100">
                  <label className="mb-3">New Display Name</label>
                  <input
                    className="n11-bg rounded-8"
                    type="text"
                    placeholder="Type new display name here..."
                    required
                    value={newDisplayName}
                    onChange={(e) => setNewDisplayName(e.target.value)}
                  />
                </div>
              </div>
              {/* <!-- <div
                            className="d-flex align-items-center gap-5 gap-md-6 mb-5 flex-wrap flex-md-nowrap">
                            <div className="w-100">
                                <label className="mb-3">Date Of Birth</label>
                                <div className="d-flex align-items-center gap-6 w-100">

                                    <div className="d-flex n11-bg rounded-8 w-50">
                                        <input type="text" placeholder="12">
                                    </div>
                                    <div className="d-flex n11-bg rounded-8 w-50">
                                        <input type="text" placeholder="09">
                                    </div>
                                    <div className="d-flex n11-bg rounded-8 w-50">
                                        <input type="text" placeholder="1999">
                                    </div>
                                </div>
                            </div>
                            <div className="w-100">
                                <label className="mb-3">Phone Number</label>
                                <div className="d-flex gap-2">
                                    <input className="w-25 n11-bg rounded-8" type="text"
                                        placeholder="+962">
                                    <input className="n11-bg rounded-8" type="text"
                                        placeholder="XX-XXX-XXXXX">
                                </div>
                            </div>
                        </div> --> */}
              {/* <!-- <div
                            className="d-flex align-items-center flex-wrap flex-md-nowrap gap-5 gap-md-6 mb-5">
                            <div className="w-100">
                                <label className="mb-3">Address</label>
                                <input className="n11-bg rounded-8" type="text"
                                    placeholder="Address...">
                            </div>
                            <div className="w-100">
                                <label className="mb-3">Country</label>
                                <select>
                                    <option data-display="Your country...">Your country...
                                    </option>
                                    <option value="1">Country 1</option>
                                    <option value="2">Country 2</option>
                                </select>
                            </div>
                        </div> --> */}
              {/* <!-- <div
                            className="d-flex align-items-center flex-wrap flex-md-nowrap gap-5 gap-md-6 mb-5">
                            <div className="w-100">
                                <label className="mb-3">Email</label>
                                <input className="n11-bg rounded-8" type="text"
                                    placeholder="Email" readOnly>
                            </div>
                            <div className="w-100">
                                <label className="mb-3">TBD...</label>
                                <input className="n11-bg rounded-8" type="text"
                                    placeholder="TBD..." readOnly>
                            </div>
                        </div> --> */}
              {/* <!-- <div className="d-flex gap-2 align-items-start align-items-xl-center mb-5">
                            <input type="checkbox" id="demoCheckbox" name="checkbox"
                                value="1">
                            <label htmlFor="demoCheckbox" className="fs-seven">I authorize to collect and transmit my personal information for identity verification or <span className="g1-color"> similar uses as defined</span> in order to confirm my ability to use the website.</label>
                        </div> --> */}
              <button className="cmn-btn py-3 px-10">Save</button>
            </form>
          </div>
        </div>
      )}
      <div className="pay_method__paymethod p-4 p-lg-6 p2-bg rounded-8 mb-5">
        <div className="pay_method__paymethod-title mb-5 mb-md-6">
          <h5 className="n10-color">Change Email Address</h5>
          <p className="fs-seven n4-color mt-2 text-warning">
            This feature will be available soon
          </p>
        </div>
        <div className="pay_method__formarea disabled-element">
          <form>
            <div className="d-flex align-items-center flex-wrap flex-md-nowrap gap-5 gap-md-6 mb-5">
              <div className="w-100">
                <label className="mb-3">New Email Address</label>
                <input
                  className="n11-bg rounded-8"
                  type="text"
                  placeholder="Type new email address here..."
                  required
                />
              </div>
            </div>
            <div className="d-flex gap-2 align-items-start align-items-xl-center mb-5">
              <input
                type="checkbox"
                id="demoCheckbox"
                name="checkbox"
                value="1"
                required
              />
              <label htmlFor="demoCheckbox" className="fs-seven">
                I authorize to collect and transmit my personal information for
                identity verification or{" "}
                <span className="g1-color"> similar uses as defined</span> in
                order to confirm my ability to use the website.
              </label>
            </div>
            <button className="cmn-btn py-3 px-10">Apply</button>
          </form>
        </div>
      </div>

      <div className="pay_method__paymethod p-4 p-lg-6 p2-bg rounded-8 mb-5">
        <div className="pay_method__paymethod-title mb-5 mb-md-6">
          <h5 className="n10-color">Change Password</h5>
          <p className="fs-seven n4-color mt-2">
            Password must be 6-20 characters, with at least one uppercase
            letter, one lowercase letter, and one number.
          </p>
        </div>
        <div className="pay_method__formarea">
          <form onSubmit={handleChangePassword}>
            <div className="d-flex align-items-center flex-wrap flex-md-nowrap gap-5 gap-md-6 mb-5">
              <div className="w-100">
                <label className="mb-3">Current Password</label>
                <input
                  className="n11-bg rounded-8"
                  type="password"
                  placeholder="Type currency password here..."
                  autoComplete="current-password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="d-flex align-items-center flex-wrap flex-md-nowrap gap-5 gap-md-6 mb-5">
              <div className="w-100">
                <label className="mb-3">New Password</label>
                <input
                  className="n11-bg rounded-8"
                  type="password"
                  placeholder="Type new password here..."
                  pattern="^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$"
                  autoComplete="new-password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="d-flex align-items-center flex-wrap flex-md-nowrap gap-5 gap-md-6 mb-5">
              <div className="w-100">
                <label className="mb-3">Confirm New Password</label>
                <input
                  className="n11-bg rounded-8"
                  type="password"
                  placeholder="Re-type new password here..."
                  autoComplete="new-password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </div>
            </div>
            {/* <!-- <div
                            className="d-flex align-items-center gap-5 gap-md-6 mb-5 flex-wrap flex-md-nowrap">
                            <div className="w-100">
                                <label className="mb-3">Date Of Birth</label>
                                <div className="d-flex align-items-center gap-6 w-100">

                                    <div className="d-flex n11-bg rounded-8 w-50">
                                        <input type="text" placeholder="12">
                                    </div>
                                    <div className="d-flex n11-bg rounded-8 w-50">
                                        <input type="text" placeholder="09">
                                    </div>
                                    <div className="d-flex n11-bg rounded-8 w-50">
                                        <input type="text" placeholder="1999">
                                    </div>
                                </div>
                            </div>
                            <div className="w-100">
                                <label className="mb-3">Phone Number</label>
                                <div className="d-flex gap-2">
                                    <input className="w-25 n11-bg rounded-8" type="text"
                                        placeholder="+962">
                                    <input className="n11-bg rounded-8" type="text"
                                        placeholder="XX-XXX-XXXXX">
                                </div>
                            </div>
                        </div> --> */}
            {/* <!-- <div
                            className="d-flex align-items-center flex-wrap flex-md-nowrap gap-5 gap-md-6 mb-5">
                            <div className="w-100">
                                <label className="mb-3">Address</label>
                                <input className="n11-bg rounded-8" type="text"
                                    placeholder="Address...">
                            </div>
                            <div className="w-100">
                                <label className="mb-3">Country</label>
                                <select>
                                    <option data-display="Your country...">Your country...
                                    </option>
                                    <option value="1">Country 1</option>
                                    <option value="2">Country 2</option>
                                </select>
                            </div>
                        </div> --> */}
            {/* <!-- <div
                            className="d-flex align-items-center flex-wrap flex-md-nowrap gap-5 gap-md-6 mb-5">
                            <div className="w-100">
                                <label className="mb-3">Email</label>
                                <input className="n11-bg rounded-8" type="text"
                                    placeholder="Email" readOnly>
                            </div>
                            <div className="w-100">
                                <label className="mb-3">TBD...</label>
                                <input className="n11-bg rounded-8" type="text"
                                    placeholder="TBD..." readOnly>
                            </div>
                        </div> --> */}
            <div className="d-flex gap-2 align-items-start align-items-xl-center mb-5">
              <input
                type="checkbox"
                id="demoCheckbox"
                name="checkbox"
                value="1"
                required
              />
              <label htmlFor="demoCheckbox" className="fs-seven">
                I have read and agreed to the{" "}
                <span className="g1-color"> Terms and Conditions</span> such
                that you understand that you bear full responsibility upon
                losing the password.
              </label>
            </div>
            <button className="cmn-btn py-3 px-10">Save</button>
          </form>
        </div>
      </div>
    </div>
  );
}
